import React, { createContext, useContext, useState, useEffect } from "react";
import { getSocket, disconnectSocket as rawDisconnect } from "../socket";

const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const s = getSocket(token);   // 🔐 now passes token in `auth`
      s.connect();                  // 🔥 triggers handshake
      setSocket(s);

      s.on("connect", () => {
        console.log("🧠 [SocketProvider] Connected with ID:", s.id);
      });

      s.on("connect_error", (err) => {
        console.error("⚠️ [SocketProvider] Connection error:", err.message || err);
      });
    }
  }, []);

  return (
    <SocketContext.Provider value={{ socket }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
